// extracted by mini-css-extract-plugin
export var table = "_y6-0";